import { SEO } from "../components/shared/SEO";
import { PageHeader } from "../components/shared/PageHeader";
import { useSettings } from "../context/SettingsContext";
import { PRIVACY, COOKIE, TERMS } from "../content/legal";

const DOCS = { privacy: PRIVACY, cookie: COOKIE, terms: TERMS };

export default function Legal({ type }) {
  const s = useSettings();
  const doc = DOCS[type](s);
  const missing = !s.vat_number || !s.registered_office;
  return (
    <>
      <SEO title={doc.title} description={`${doc.title} di ${s.company_name}. ${doc.subtitle}`} />
      <PageHeader compact eyebrow="Note legali" title={doc.title} text={doc.subtitle} />
      <section className="section bg-cream">
        <div className="container-hh max-w-4xl" data-testid={`legal-${type}`}>
          <nav aria-label="Indice" className="mb-12 flex flex-wrap gap-x-6 gap-y-2 text-xs uppercase tracking-[0.18em] text-stone">
            {doc.sections.map(([h], i) => <a key={i} href={`#sez-${i + 1}`} className="hover:text-gold transition-colors">{h.replace(/^\d+\.\s*/, "")}</a>)}
          </nav>
          {doc.sections.map(([h, paras], i) => (
            <div key={h} id={`sez-${i + 1}`} className="py-8 border-b border-ink/10 scroll-mt-32">
              <h2 className="font-sans text-xs uppercase tracking-[0.25em] font-medium text-ink mb-5">{h}</h2>
              {paras.map((p, j) => (
                <p key={j} className={`lead !text-base ${p.startsWith("•") ? "pl-5 -indent-3 mt-1" : "mt-3"}`}>{p}</p>
              ))}
            </div>
          ))}
          <p className="text-xs text-stone mt-8">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</p>
          {missing && <p className="text-xs text-red-700 mt-2" data-testid="legal-missing-data">Nota per l'amministratore (visibile finché i dati non sono completi): inserire P.IVA e sede legale in Impostazioni → Dati legali.</p>}
        </div>
      </section>
    </>
  );
}
